import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOrg from './org.reducer';

export const selectOrgState = createFeatureSelector<fromOrg.State>(fromOrg.orgFeatureKey);

export const selectCurrent = createSelector(selectOrgState, (state) => state.current);

export const selectReport = createSelector(selectOrgState, (state) => state.report);

export const selectCanCreateOrgCollection = createSelector(
  selectCurrent,
  (org) => org?.membershipType === 'admin' || !org?.adminCollectionCreationOnly
);

export const selectReportThemeSettingsLink = createSelector(selectReport, (owner) => owner?.links.themesSettings);
